import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MessagesListComponent } from './messages-list/messages-list.component';
import { MatMenuModule } from '@angular/material/menu';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MessagesRoutingModule } from './messages-routing.module';
import { CreateMessageComponent } from './create-message/create-message.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MessagesContainerComponent } from './messages-container/messages-container.component';
import { ViewMessageListComponent } from './components/viewMessageList/view-message-list/view-message-list.component';
import { ViewSideMessagesTitlesComponent } from './components/viewMessageList/view-side-messages-titles/view-side-messages-titles.component';
import { ViewMessageDetailsComponent } from './components/viewMessageList/view-message-details/view-message-details.component';
import { ViewMessageContentComponent } from './components/viewMessageList/view-message-content/view-message-content.component';
import { MessageTitleComponent } from './components/viewMessageList/message-title/message-title.component';
import { SharedModule } from '../shared/shared.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { MessagesCompactViewComponent } from './components/viewMessagesCompact/messages-compact-view/messages-compact-view.component';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import { QuillModule } from 'ngx-quill';
import {MatDialogModule} from '@angular/material/dialog';
import { SelectUsersManuallyComponent } from './components/select-users-manually-popup/select-users-manually.component';
import { MessageRecepientsComponent } from './components/message-recepients-popup/message-recepients.component';
import { MessageViewComponent } from './components/message-view-popup/message-view.component';
import { MiniImageComponent } from './components/mini-image/mini-image.component';
import { ImagePopupComponent } from './components/image-popup/image-popup.component';


@NgModule({
  declarations: [MessagesListComponent, CreateMessageComponent, MessagesContainerComponent, ViewMessageListComponent, ViewSideMessagesTitlesComponent, ViewMessageDetailsComponent, ViewMessageContentComponent, MessageTitleComponent, MessagesCompactViewComponent, SelectUsersManuallyComponent, MessageRecepientsComponent, MessageViewComponent, MiniImageComponent, ImagePopupComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MessagesRoutingModule,
    MatSnackBarModule,
    MatMenuModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    AngularEditorModule,
    SharedModule,
    InfiniteScrollModule,
    MatInputModule,
    MatSelectModule,
    QuillModule.forRoot(),
    MatDialogModule
    ]
})
export class MessagesModule { }
